import { render } from "./addClient.vue?vue&type=template&id=4e9a6e41&scoped=true"
import script from "./addClient.vue?vue&type=script&lang=js"
export * from "./addClient.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./addClient.vue?vue&type=style&index=1&id=4e9a6e41&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9a6e41"]])

export default __exports__